import { AgentType } from '../models/agent-type.enum';

export interface AgentConfiguration {
  User:string;
  sidebar: string[];
  landingPage: string;
  services: boolean;
  transactions: boolean;
  defaultPrincipal?: string,
  showBalance:boolean,
  pendingTransactions:boolean,
  finalTransactions:boolean,
  showAgentDetails:boolean,
  allowedServices?: string[];
  // requiresLocationSelection: boolean;
}

export const AGENT_CONFIG: Record<AgentType, AgentConfiguration> = {

  // Default agent configuration
  [AgentType.NORMAL]: {
    User:'Agent',
    sidebar: ['*'],
    landingPage: '/agent/dashboard',
    services: true,
    transactions: true,
    showBalance:true,
    pendingTransactions:true,
    finalTransactions:true,
    showAgentDetails:true,
    allowedServices: ['*']
    // requiresLocationSelection: true
  },

  // Novibet agent configuration
  [AgentType.NOVIBET]: {
    sidebar: ['Transaction-Final Status Transaction','Tools-Search Transaction','Other-DirectPay Location'],
    User:'NovibetUser',
    landingPage: '/agent/transaction-center',
    services: false,
    transactions: true,
    defaultPrincipal: 'NOVIBET',
    showAgentDetails:false,
    showBalance:false,
    pendingTransactions:false,
    finalTransactions:true,
    allowedServices: [
      'Cash Deposit','Cash Withdrawal'
    ]
    // requiresLocationSelection: false
  }

};